import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SvgAddPlus24Px(props) {
    return (_jsxs("svg", Object.assign({ height: 24, width: 24 }, props, { children: [_jsx("path", { d: "M0 0h24v24H0z", fill: "none" }), _jsx("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" })] })));
}
export default SvgAddPlus24Px;
